export default function Checkbox(props) {
  const { id, input, disabled, wrapperClasses, className, meta: { touched, error, warning } } = props
  const forId = `${input.name}-${input.value}-${id}`

  return (
    <div className={`${disabled && 'disabled'} ${wrapperClasses}`}>
      <div className="custom-control custom-checkbox">
        <input
          {...input}
          id={forId}
          type="checkbox"
          checked={input.value}
          className={`custom-control-input ${className}`}
        />
        <label className="custom-control-label" htmlFor={forId}>
          {props.label}
        </label>
      </div>
      {touched &&
        ((error && <span className="invalid-feedback text-danger d-inline">{error}</span>) ||
          (warning && <span>{warning}</span>))}
    </div>
  )
}